import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog",
  ref: "myModal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.showModal && $options.showModal(...args))
  }, "Show Modal"), _createElementVNode("div", _hoisted_1, _cache[1] || (_cache[1] = [_createElementVNode("div", {
    class: "modal-dialog",
    role: "document"
  }, [_createElementVNode("div", {
    class: "modal-content"
  }, [_createElementVNode("div", {
    class: "modal-header"
  }, [_createElementVNode("h5", {
    class: "modal-title"
  }, "Modal title"), _createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [_createElementVNode("span", {
    "aria-hidden": "true"
  }, "×")])]), _createElementVNode("div", {
    class: "modal-body"
  }, [_createElementVNode("p", null, "Modal body text goes here.")]), _createElementVNode("div", {
    class: "modal-footer"
  }, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-dismiss": "modal"
  }, "Close"), _createElementVNode("button", {
    type: "button",
    class: "btn btn-primary"
  }, "Save changes")])])], -1)]), 512)]);
}